/**
 * Klucze configu źródła integracji dla `target_entity_type=contract` (intake umowy finansowej).
 * Backend (GenericIntegrationSource.handleContract) czyta dokładnie te klucze.
 */
export const CONTRACT_CONFIG_KEYS = [
  'configuration_code',
  'land_on_stage',
  'assign_to_team',
  'client_pesel_path',
  'client_first_name_path',
  'client_last_name_path',
  'second_party_pesel_path',
  'second_party_first_name_path',
  'second_party_last_name_path',
  'sales_rep_halo_id_path',
  'external_key_path',
] as const

export type ContractConfigKey = (typeof CONTRACT_CONFIG_KEYS)[number]
export type ContractConfig = Record<ContractConfigKey, string>

/**
 * Wymagane klucze, bez których intake umowy nie zadziała. `external_key_path` jest
 * OPCJONALNY - to identyfikator pvslides do idempotencji (ochrona przed duplikatami przy
 * retry), NIE numer umowy (ten generuje easycrm sam). Bez niego intake działa, tylko bez dedupu.
 */
export const REQUIRED_CONTRACT_KEYS: ContractConfigKey[] = [
  'configuration_code',
  'land_on_stage',
  'assign_to_team',
  'client_pesel_path',
]

export function emptyContractConfig(): ContractConfig {
  return Object.fromEntries(CONTRACT_CONFIG_KEYS.map(k => [k, ''])) as ContractConfig
}

/** Wyciąga wartości kluczy contract z dowolnego configu źródła (na potrzeby edycji). */
export function readContractConfig(config: Record<string, unknown>): ContractConfig {
  const result = emptyContractConfig()
  for (const k of CONTRACT_CONFIG_KEYS) {
    const v = config[k]
    if (typeof v === 'string') result[k] = v
  }
  return result
}

/** Zwraca klucze configu contract jako obiekt do wysłania (puste stringi pomijane). */
export function contractConfigToPayload(cfg: ContractConfig): Record<string, string> {
  const out: Record<string, string> = {}
  for (const k of CONTRACT_CONFIG_KEYS) {
    const v = cfg[k].trim()
    if (v) out[k] = v
  }
  return out
}

/** Lista brakujących wymaganych kluczy (pusta = OK). */
export function missingRequiredContractKeys(cfg: ContractConfig): ContractConfigKey[] {
  return REQUIRED_CONTRACT_KEYS.filter(k => !cfg[k].trim())
}
